import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { Dropdown, DropdownIconType, IDropdownOption } from 'components/forms'
import { TableRow, TableCell } from 'transfix-ui'
import { ISpotBiddingConfig, RULE_ACTION, CONFIG_TYPE } from '../types/spotBiddingConfig'

interface ISpotBiddingConfigsTableProps {
  spotBiddingConfig: ISpotBiddingConfig
  openEditModal: (config: ISpotBiddingConfig) => void
  openDeleteModal: (config: ISpotBiddingConfig) => void
}

export const SpotBiddingConfigsTableRow = memo<ISpotBiddingConfigsTableProps>(
  ({ openDeleteModal, openEditModal, spotBiddingConfig }) => {
    const openEditConfigModal = () => openEditModal(spotBiddingConfig)
    const openDeleteConfigModal = () => openDeleteModal(spotBiddingConfig)

    const options: IDropdownOption[] = [
      {
        label: 'Edit Segment',
        action: openEditConfigModal,
      },
      {
        label: 'Delete Segment',
        action: openDeleteConfigModal,
      },
    ]

    const {
      baselineRuleAction,
      baselineRulePremiumAmount,
      configName,
      configType,
      id,
      shipperApplications,
    } = spotBiddingConfig

    const shipperSegmentName = configType === CONFIG_TYPE.default ? 'Default' : configName || ''
    const shipperListMsg = (() => {
      let msg = ''
      const numShippers = shipperApplications?.length
      for (const [i, shipper] of shipperApplications?.entries()) {
        msg += shipper.name
        const numShippersLeft = numShippers - (i + 1)
        if (numShippersLeft && msg.length > 50) {
          msg += ` and ${numShippersLeft} other(s)`
          break
        } else if (i !== numShippers - 1) {
          msg += ', '
        }
      }

      return msg
    })()

    const percentage = baselineRulePremiumAmount
      ? `${Number((Number(baselineRulePremiumAmount) * 100).toFixed(1))}%`
      : ''
    const premium = baselineRuleAction === RULE_ACTION.dontBid ? "Don't Bid" : percentage

    const configLink = `/${id}`

    return (
      <TableRow dataTest={`spot-bidding-config-${id}`} highlightOnHover>
        <TableCell>
          <Link to={configLink}>{shipperSegmentName}</Link>
        </TableCell>
        <TableCell>{shipperListMsg || ''}</TableCell>
        <TableCell>{premium}</TableCell>
        <TableCell>Baseline</TableCell>
        <TableCell>
          <Dropdown
            options={options}
            icon={DropdownIconType.ellipsis}
            dataTest={`modal-actions-config-${id}`}
          />
        </TableCell>
      </TableRow>
    )
  }
)
